import type { Service } from '@/types';

export const services: Service[] = [
  // ── DIGITAL PRODUCTS ──────────────────────────────────────────────
  {
    id: 'web-development',
    icon: 'code',
    title: 'Web Development',
    description:
      'Modern websites and web applications built around business goals, usability, performance, and scalability.',
    features: ['Business-Focused Websites', 'Web Applications', 'Performance Optimization', 'Responsive Design'],
    color: 'blue',
  },
  {
    id: 'mobile-app-development',
    icon: 'smartphone',
    title: 'Mobile App Development',
    description:
      'Mobile applications designed and developed for modern digital experiences.',
    features: ['iOS & Android', 'Cross-Platform', 'App Store Deployment', 'Modern Frameworks'],
    color: 'purple',
  },
  {
    id: 'ui-ux-design',
    icon: 'layers',
    title: 'UI/UX Design',
    description:
      'User-focused interface and experience design for websites, applications, and digital products.',
    features: ['Interface Design', 'User Experience', 'Prototyping', 'Design Systems'],
    color: 'orange',
  },

  // ── TECHNOLOGY ────────────────────────────────────────────────────
  {
    id: 'ai-automation',
    icon: 'cpu',
    title: 'AI & Automation',
    description:
      'AI-powered features and workflow automation designed to improve products and business processes.',
    features: ['AI-Powered Features', 'Workflow Automation', 'Intelligent Solutions', 'Process Optimization'],
    color: 'blue',
  },
  {
    id: 'cloud-solutions',
    icon: 'cloud',
    title: 'Cloud Solutions',
    description:
      'Cloud, hosting, deployment, and infrastructure solutions for digital products.',
    features: ['Cloud Infrastructure', 'Deployment', 'Hosting', 'DevOps'],
    color: 'purple',
  },
  // ── DIGITAL GROWTH ────────────────────────────────────────────────
  {
    id: 'digital-marketing',
    icon: 'megaphone',
    title: 'Digital Marketing',
    description:
      'Digital marketing solutions designed to help businesses strengthen their online presence.',
    features: ['Online Presence', 'Campaign Strategy', 'Social Media', 'Content Marketing'],
    color: 'purple',
  },
  {
    id: 'seo',
    icon: 'search',
    title: 'SEO',
    description:
      'Search optimization strategies focused on improving online visibility and discoverability.',
    features: ['Search Optimization', 'Visibility', 'Keyword Strategy', 'Technical SEO'],
    color: 'orange',
  },
  {
    id: 'hosting',
    icon: 'server',
    title: 'Hosting',
    description:
      'Hosting and deployment services for websites and digital products.',
    features: ['Web Hosting', 'Deployment', 'Domain Management', 'Uptime Monitoring'],
    color: 'blue',
  },
  {
    id: 'brand-identity',
    icon: 'palette',
    title: 'Logo & Brand Identity',
    description:
      'Visual identity and logo design for businesses and digital products.',
    features: ['Logo Design', 'Visual Identity', 'Brand Guidelines', 'Brand Strategy'],
    color: 'purple',
  },
  {
    id: 'ugc-advertisements',
    icon: 'video',
    title: 'UGC Advertisements',
    description:
      'User-generated-content-style advertising creatives designed for digital marketing campaigns.',
    features: ['UGC Creatives', 'Ad Production', 'Campaign Assets', 'Social Ads'],
    color: 'orange',
  },
];
